import { useContext } from "react";
import { LobbyContext } from "../pages/v4/LobbyContextProvider";

export default function useLobbyContext() {
  const context = useContext(LobbyContext);

  return context;
}
